import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";

import { PRODUCT_CACHE_KEYS } from "./keys";

import { ProductRepository } from "@/repositories/product";
import { ProductFilters } from "@/types";

export const useGetAllProducts = (filters: ProductFilters) => {
  const productRepository = useRef(new ProductRepository());

  return useQuery({
    queryKey: PRODUCT_CACHE_KEYS.LIST(filters),
    queryFn: async () => {
      return await productRepository.current.findAll(filters);
    },
  });
};
